import React, { Component } from "react";
import styled from "styled-components";
import { Button, Card, CardBody, Col, Row } from "reactstrap";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import {
  getPlans,
  deleteMediaBuyerPlanByOffer,
  addMediaBuyerPlanByOffer,
  getFilteredPlans,
} from "../../../store/mediabuyers/mediabuyerplans/actions";
import { getMediaBuyerDataForAdd } from "../../../store/mediabuyers/mediabuyerbudget/actions";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import { withRouter } from "react-router-dom";
import ModalMediaBuyerPlan from "./components/ModalMediaBuyerPlan";
import FormToFilter from "./../../../components/forms/FormToFilter";

class OfferMediaBuyersPlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      budgetFilter: false,
      viewAddBudget: false
    };
  }

  handleTableChange = data => {
    this.props.getMediaBuyerPlans(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddBudgetModal = () => {
    this.setState(prevState => ({
      viewAddBudget: !prevState.viewAddBudget
    }));
  };

  render() {
    const onClickEdit = (e, row) => {
      this.props.history.push(
        `/offers/${this.props.offer.id}/media-buyer-plan/${row.id}`
      );
    };

    const legalNameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => onClickEdit(e, row)}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.media_buyer}"!`,
          onConfirm: () => {
            this.props.deleteMediaBuyerPlanByOffer(row.id, row.offer);
            this.handleChangeDeleteAlert(null);
          }
        });
      };

      return (
        <>
          {this.props.permissions?.["change_mediabuyerplanmodel"] && (
            <button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickEdit(e, row)}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16"/>
            </button>
          )}
          {this.props.permissions?.["delete_mediabuyerplanmodel"] && (
            <button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16"/>
            </button>
          )}
        </>
      );
    };

    const columns = [
      {
        dataField: "media_buyer",
        text: "Media buyer name",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "media_buyer")
      },
      {
        dataField: "planned_sum",
        text: "Planned sum",
        sort: true,
        formatter: (e, row) => legalNameFormatter(e, row, "planned_sum")
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter
      }
    ];

    return (
      <React.Fragment>

        {this.state.viewAddBudget && (
          <ModalMediaBuyerPlan
            toggle={this.toggleViewAddBudgetModal}
            isOpen={this.state.viewAddBudget}
            data={this.props.dataForAddBudget}
            currentMedia={this.props.data}
            addMediaBuyerPlan={this.props.addMediaBuyerPlanByOffer}
            offerId={this.props.offer.id}
          />
        )}

        {this.state.deleteAlert && (
          <SweetAlert
            showCancel
            confirmBtnText="Delete"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle=""
            title={this.state.deleteAlert.title}
            onCancel={() => this.handleChangeDeleteAlert(null)}
            onConfirm={this.state.deleteAlert.onConfirm}
          >
            <p>Are you sure want to delete a budget plan?</p>
          </SweetAlert>
        )}

        <FormToFilter
          data={this.props.data}
          dataForAddBudget={this.props.dataForAddBudget}
          getFilteredRequest={this.props.getFilteredPlans}
          offerId={this.props.offer?.id}
          FilterType="plans"
          history={this.props.history}
        />

        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <RemoteTable
                  onTableChange={this.handleTableChange}
                  columns={columns}
                  data={this.props.data}
                  loading={this.props.loading}
                >
                  {this.props.permissions?.["add_mediabuyerplanmodel"] && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-rounded mb-2 me-2"
                      onClick={this.toggleViewAddBudgetModal}
                    >
                      <i className="mdi mdi-plus me-1"/> Add media buyer plan
                    </Button>
                  )}
                </RemoteTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const LegalNameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

OfferMediaBuyersPlans.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  getMediaBuyerPlans: PropTypes.func.isRequired,
  deleteMediaBuyerPlanByOffer: PropTypes.func.isRequired,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  dataForAddBudget: PropTypes.object,
  addMediaBuyerPlanByOffer: PropTypes.func.isRequired,
  getFilteredPlans: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  isError: PropTypes.bool,
  offer: PropTypes.any
};

const mapStateToProps = state => ({
  data: state.MediaBuyerPlans.data,
  loading: state.MediaBuyerPlans.loading,
  permissions: state.User.permissions,
  dataForAddBudget: state.MediaBuyerBudgets.dataForAddBudget,
  isError: state.MediaBuyerPlans.isError
});

export default connect(mapStateToProps, {
  getMediaBuyerPlans: getPlans,
  deleteMediaBuyerPlanByOffer,
  getMediaBuyerDataForAdd,
  addMediaBuyerPlanByOffer,
  getFilteredPlans,
})(withRouter(OfferMediaBuyersPlans));
